/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventParty,
    JsonEventPartyFromJSON,
    JsonEventPartyFromJSONTyped,
    JsonEventPartyToJSON,
} from './JsonEventParty';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonEventParty
 */
export interface ApiResultOfListOfJsonEventParty {
    /**
     * 
     * @type {Array<JsonEventParty>}
     * @memberof ApiResultOfListOfJsonEventParty
     */
    data?: Array<JsonEventParty>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventParty
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonEventParty
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventParty
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventParty
     */
    result?: ApiResultOfListOfJsonEventPartyResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonEventPartyResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonEventPartyFromJSON(json: any): ApiResultOfListOfJsonEventParty {
    return ApiResultOfListOfJsonEventPartyFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonEventPartyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonEventParty {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonEventPartyFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonEventPartyToJSON(value?: ApiResultOfListOfJsonEventParty | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonEventPartyToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

